import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { generatereport } from '../models/generatereport.model';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  private Url: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string, private _authentication: AuthenticationService) {
    this.Url = baseUrl;
  }

  getReportByIdRole() {
    let params = new HttpParams().set("idUserRole", this._authentication.currentUserValue.fkUserRole.toString());
    return this.http.get(this.Url + 'api/reports/GetReportByIdRole', { params: params });
  }

  getFiltersByIdReport(idReport: number) {
    let params = new HttpParams().set("idReport", idReport.toString());
    return this.http.get(this.Url + 'api/reports/GetFiltersByIdReport', { params: params });
  }

  generateReport(infoReporte: generatereport) {
    infoReporte.idUser = this._authentication.currentUserValue.idUser;
    infoReporte.idUserAgentkey = this._authentication.currentUserValue.fkAgentKey;
    infoReporte.idUserOffice = this._authentication.currentUserValue.fkIdOffice;
    infoReporte.idUserRole = this._authentication.currentUserValue.fkUserRole;

    return this.http.post(this.Url + 'api/reports/GenerateReport', infoReporte, { responseType: 'blob' });
  }

}
